// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMemoMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateMemoInput;
}>;


export type UpdateMemoMutation = { __typename?: 'Mutation', updateMemo: { __typename?: 'Memo', id: string } };

export const Operations = {
  Mutation: {
    UpdateMemo: 'UpdateMemo' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateMemoDocument = gql`
    mutation UpdateMemo($input: AugmentedUpdateMemoInput!) {
  updateMemo(input: $input) {
    id
  }
}
    `;
export type UpdateMemoMutationFn = Apollo.MutationFunction<UpdateMemoMutation, UpdateMemoMutationVariables>;

/**
 * __useUpdateMemoMutation__
 *
 * To run a mutation, you first call `useUpdateMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemoMutation, { data, loading, error }] = useUpdateMemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemoMutation, UpdateMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemoMutation, UpdateMemoMutationVariables>(UpdateMemoDocument, options);
      }
export type UpdateMemoMutationHookResult = ReturnType<typeof useUpdateMemoMutation>;
export type UpdateMemoMutationResult = Apollo.MutationResult<UpdateMemoMutation>;
export type UpdateMemoMutationOptions = Apollo.BaseMutationOptions<UpdateMemoMutation, UpdateMemoMutationVariables>;